import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ebb-integration-dialog-solutiondeploying',
    templateUrl: './dialog-solutiondeploying.component.html',
    standalone: false
})
export class DialogSolutionDeployingComponent implements OnInit {
  public formPermissions: FormGroup;
  public disableGrantSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogSolutionDeployingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder  
  ) { }

  ngOnInit() {
  }
}
